'use client';

import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { TextButton } from '@app/app/_components/TextButton/TextButton';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { PremiumsPaymentSchedule } from '@app/domain/model/eshop/transport/PremiumsPaymentSchedule';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { format } from 'date-fns';
import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';

interface Props {
    schedule: PremiumsPaymentSchedule[];
}

export function PaymentSchedule({ schedule }: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = useCallback(() => {
        setShowAll(prev => !prev);
    }, []);

    if (!schedule || schedule.length === 0) return null;

    const displayedSchedule = showAll ? schedule : schedule.slice(0, 2);
    const hasMore = schedule.length > 2;

    return (
        <div className="flex flex-col gap-4 rounded-lg bg-neutral-50 p-4">
            <Paragraph isBold>{t('eshop.general.paymentSchedule')}</Paragraph>
            <div className="flex flex-col gap-4">
                {displayedSchedule.map((item, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-between border-b border-neutral-200 pb-2 last:border-b-0 last:pb-0">
                        <Paragraph>{format(new Date(item.date), 'yyyy-MM-dd')}</Paragraph>
                        <Paragraph className="font-medium">{formatEuroValue(item.amountAfterDiscount, tenant)}</Paragraph>
                    </div>
                ))}
            </div>
            {hasMore && (
                <TextButton onClick={toggleShowAll} rightAddon={<ArrowRightIcon className="size-4" />} size="small">
                    {showAll ? t('general.showLess') : t('general.showAll')}
                </TextButton>
            )}
        </div>
    );
}
